import BaseService from './baseService'
class Sistema extends BaseService {
  constructor(id) {
    const resource = ''
    const relationship = {
      autores: 'autores',
      bibliotecas: 'bibliotecas',
      bibliotecarios: 'bibliotecarios',
      categoriasObras: 'categorias-obras',
      editoras: 'editoras',
      emprestimos: 'emprestimos',
      exemplares: 'exemplares',
      formatosExemplares: 'formatos-exemplares',
      leitores: 'leitores',
      metas: 'metas',
      obras: 'obras',
      obrasAutores: 'obras-autores',
      postagens: 'postagens',
      reservas: 'reservas',
      statusEmprestimos: 'status-emprestimos',
      statusExemplares: 'status-exemplares',
      statusPostagens: 'status-postagens',
      statusReservas: 'status-reservas',
      sugestoesObras: 'sugestoes-obras',
      estados: 'estados',
      users: 'users'
    }
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Sistema(id)
